import { gEnums } from 'global/enums/globalEnums'
import React, { useMemo } from 'react'
import { SectionHeader } from '../schedule/SectionHeader'
import { _matchDisplayTypes } from './MatchContent'
import { MatchesDate } from './MatchesDate'

const SectionSchedule = React.memo(({
  levelKey,
  sectionKey,
  matches_sections,
  dateKey,
  teamKey,
  matchDisplayType = _matchDisplayTypes.scoreboard,
  matchScheduleDisplayType = gEnums.matchScheduleDisplayTypes.scoreboard,
  team_fav_keys = [],
}) => {

  const sectionHeader = <SectionHeader sectionKey={sectionKey} levelKey={levelKey} />

  const sortedMatches = _.orderBy(
    _.values(matches_sections || {}),
    [
      match => !!match?.results,
      match => match?.home?.name?.toLowerCase() || ''
    ],
    ['desc', 'asc']
  );

  const sectionMatches = useMemo(() => {
    const matches_section = !_.isEmpty(sortedMatches) ? <MatchesDate
      levelKey={levelKey}
      sectionKey={sectionKey}
      dateKey={dateKey}
      matches={sortedMatches}
      teamKey={teamKey}
      matchDisplayType={matchDisplayType}
      matchScheduleDisplayType={matchScheduleDisplayType}
      team_fav_keys={team_fav_keys}
    /> : <div className='match-wrapper'>No Matches</div>
    return matches_section
  }, [sortedMatches])

  const div_section = <div className='match-date-matches ss'>
    {sectionHeader}
    {sectionMatches}
  </div>

  return div_section

})

export default SectionSchedule
